"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionRootContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _extend = _interopRequireDefault(require("lodash/extend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ActionRootContext = /*#__PURE__*/(0, _react.createContext)({
  editable: {},
  dispatcher: {}
});
exports.ActionRootContext = ActionRootContext;

var ActionRoot = function ActionRoot(View, pageStores, editable, dispatcher) {
  var WrappedActionRoot = (0, _createReactClass.default)({
    displayName: "WrappedActionRoot",
    componentDidMount: function componentDidMount() {
      if (pageStores.ContentStore) {
        pageStores.ContentStore.loadAsync();
      }
    },
    render: function render() {
      var contextValue = (0, _extend.default)({}, {
        editable: editable,
        dispatcher: dispatcher
      }, pageStores || {});
      return /*#__PURE__*/_react.default.createElement(ActionRootContext.Provider, {
        value: contextValue
      }, /*#__PURE__*/_react.default.createElement(View, null));
    }
  });
  return WrappedActionRoot;
};

var _default = ActionRoot;
exports.default = _default;